import React from 'react';

import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { AddAttributesWrapper } from '@confluence/analytics/entry-points/AddAttributesWrapper.ts';

import { TWG_ANALYTICS_SOURCES } from './analytics.ts';
import { getTwgTraceId } from './twgTraceId.ts';

const addTwgTraceId = (payload: AnalyticsEventPayload): AnalyticsEventPayload => {
	// Confluence events are `{ type, data }`; a payload without `data` is not one of ours.
	const { data } = payload;
	if (!data || !TWG_ANALYTICS_SOURCES.includes(data.source)) {
		return payload;
	}
	return {
		...payload,
		data: {
			...data,
			attributes: {
				...data.attributes,
				twgTraceId: getTwgTraceId(),
			},
		},
	};
};

/**
 * Mount above each of this package's React roots — the byline and the preview panel are separate
 * trees, and an unwrapped root fires its events with no trace id.
 */
export const TwgTraceIdAnalyticsWrapper = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<AddAttributesWrapper eventUpdater={addTwgTraceId} channel="*">
		{children}
	</AddAttributesWrapper>
);
